import { rtkQueryApi } from "../../redux/api/rtkQueryApi.tsx";

const upsellsEndpoints = rtkQueryApi.enhanceEndpoints({
  addTagTypes: [],
});

export const upsellsApi = upsellsEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    getUpsellSuggestions: builder.query<
      {
        data: {
          id: number;
          reason: string;
        }[];
      },
      { name: string; quantity: number }[]
    >({
      query: (items) => {
        return {
          url: `/v5_2/upsells/get_suggestions`,
          method: "POST",
          body: { shopping_cart_items: items },
        };
      },
    }),
  }),
});

export const { useLazyGetUpsellSuggestionsQuery } = upsellsApi;
